import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Invoice} from '../../models/accounting/invoice';
import {AuthService} from '../auth/auth.service';
import {UploadFile} from '../../models/upload-file';
import {Observable, map} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends AbstractModelService<Invoice> {
  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/invoice', Invoice);
  }

  getDownloadPdfUrl(id: number): string {
    return this.apiClient.getUrl(this.routePath + '/' + id + '/download', {token: this.authService.getBearer()});
  }

  getInvoiceFile(id: number): Observable<Blob> {
    return this.apiClient.download(this.routePath + '/' + id + '/invoice-file');
  }

  updateInvoiceFile(id: number, uploadFile: UploadFile): Observable<void> {
    return this.apiClient.put(this.routePath + '/' + id + '/invoice-file', {}, {
      invoiceFile: {
        filename: String(uploadFile.filename).replace(/[\\/%]/g, '-'),
        data: uploadFile.data
      }
    }).pipe(map(() => undefined));
  }
}
